import {
    createRouter,
    createWebHistory
} from "vue-router";

const routes = [{
        path: "/",
        redirect: "/index"
    }, {

        path: "/login",
        name: "login",
        component: () => import("../views/public/login.vue"),

    },
    {

        path: "/echarts",
        name: "echarts",
        component: () => import("../views/public/echarts.vue"),

    },
    {
        path: "/index",
        name: "index",
        component: () => import("../views/public/index.vue"),
        children: [{
            path: '/advertisement/manage',

            meta: {
                title: '广告主管理',
                name: 'advertisers',
            },
            component: () => import('../views/advertisement/manage.vue')
        }, {
            path: '/advertisement/addManage',
            meta: {
                title: '添加广告主'
            },
            component: () => import('../views/advertisement/addManage.vue')
        }, {
            path: '/advertisement/editManage',
            meta: {
                title: '编辑广告主'
            },
            component: () => import('../views/advertisement/addManage.vue')
        }, {
            path: '/advertisement/manageInfo',
            meta: {
                title: '广告主详情'
            },
            component: () => import('../views/advertisement/manageInfo.vue')
        }, {
            path: '/advertisement/manageSpace',

            meta: {
                title: '广告位管理',
                name: 'advertising_space',
            },
            component: () => import('../views/advertisement/manageSpace.vue')
        }, {
            path: '/advertisement/addManageSpace',
            meta: {
                title: '添加广告位'
            },
            component: () => import('../views/advertisement/addManageSpace.vue')
        }, {
            path: '/advertisement/editManageSpace',
            meta: {
                title: '编辑广告位'
            },
            component: () => import('../views/advertisement/addManageSpace.vue')
        }, {
            path: '/advertisement/package',

            meta: {
                title: '广告项目',
                name: 'advertising_package',
                keepAlive:true
            },
            component: () => import('../views/advertisement/package.vue')
        }, {
            path: '/advertisement/packageInfo',
            meta: {
                title: '广告项目详情'
            },
            component: () => import('../views/advertisement/packageInfo.vue')
        }, {
            path: '/advertisement/addPackage',
            meta: {
                title: '新增广告项目'
            },
            component: () => import('../views/advertisement/addPackage.vue')
        }, {
            path: '/advertisement/editPackage',
            meta: {
                title: '编辑广告项目'
            },
            component: () => import('../views/advertisement/addPackage.vue')
        }, {
            path: '/salesman/index',

            meta: {
                title: '业务员',
                name: 'sales',
            },
            component: () => import('../views/salesman/index.vue')
        }, {
            path: '/salesman/add',
            meta: {
                title: '新增业务员'
            },
            component: () => import('../views/salesman/add.vue')
        }, {
            path: '/salesman/edit',
            meta: {
                title: '编辑业务员'
            },
            component: () => import('../views/salesman/add.vue')
        }, {
            path: '/salesman/info',
            meta: {
                title: '业务员详情'
            },
            component: () => import('../views/salesman/info.vue')
        }, {
            path: '/terminal/index',
            meta: {
                title: '终端',
                name: 'terminal_list',
                keepAlive: true
            },
            component: () => import('../views/terminal/index.vue')
        }, {
            path: '/terminal/report',
            meta: {
                title: '终端报表',
                name:'report'
            },
            component: () => import('../views/terminal/report.vue')
        }, {
            path: '/terminal/info',
            meta: {
                title: '终端详情'
            },
            component: () => import('../views/terminal/components/terminalInfo.vue')
        }, {
            path: '/terminal/classification',

            meta: {
                title: '终端分类',
                name: 'terminal_classify',
            },
            component: () => import('../views/terminal/classification.vue')
        }, {
            path: '/terminal/approval',

            meta: {
                title: '终端审核',
                name: 'terminal_approval',
            },
            component: () => import('../views/terminal/approval.vue')
        }, {
            path: '/system/roleIndex',

            meta: {
                title: '角色管理',
                name: 'role',
            },
            component: () => import('../views/system/index.vue')
        }, {
            path: '/system/addRole',
            meta: {
                title: '添加角色'
            },
            component: () => import('../views/system/add.vue')
        }, {
            path: '/system/editRole',
            meta: {
                title: '编辑角色'
            },
            component: () => import('../views/system/add.vue')
        }, {
            path: '/system/userIndex',

            meta: {
                title: '系统用户管理',
                name: 'system_user',
            },
            component: () => import('../views/system/userIndex.vue')
        }, {
            path: '/system/addUser',
            meta: {
                title: '新增用户'
            },
            component: () => import('../views/system/addUser.vue')
        }, {
            path: '/system/menuIndex',

            meta: {
                title: '菜单管理',
                name: 'menu',
            },
            component: () => import('../views/system/menuIndex.vue')
        }, {
            path: '/contract/template',

            meta: {
                title: '合约模板',
                name: 'contract_template',
            },
            component: () => import('../views/contract/template.vue')
        }, {
            path: '/contract/addTemplate',
            meta: {
                title: '添加合约模板'
            },
            component: () => import('../views/contract/addTemplate.vue')
        }, {
            path: '/contract/editTemplate',
            meta: {
                title: '编辑合约模板'
            },
            component: () => import('../views/contract/addTemplate.vue')
        }, {
            path: '/contract/contractList',

            meta: {
                title: '合约管理',
                name: 'contract',
                keepAlive:true
            },
            component: () => import('../views/contract/contractList.vue')
        }, {
            path: '/contract/contractInfo',
            meta: {
                title: '合约详情'
            },
            component: () => import('../views/contract/contractInfo.vue')
        }, {
            path: '/contract/escalation',

            meta: {
                title: '上报记录',
                name: 'escalation',
                keepAlive:true
            },
            component: () => import('../views/contract/escalation.vue')
        }, {
            path: '/contract/escalationInfo',
            meta: {
                title: '上报记录详情'
            },
            component: () => import('../views/contract/escalationInfo.vue')
        }, {
            path: '/contract/escalationApproval',
            meta: {
                title: '上报广告位审核'
            },
            component: () => import('../views/contract/escalationApproval.vue')
        }, {
            path: '/enterprise/info',
            meta: {
                title: '企业信息'
            },
            component: () => import('../views/enterprise/index.vue')
        }, {
            path: '/enterprise/edit',
            meta: {
                title: '编辑企业信息'
            },
            component: () => import('../views/enterprise/edit.vue')
        }, {
            path: '/fund/salesDetail',
            meta: {
                title: '业务员资金明细',
                name:'sales_fund'
            },
            component: () => import('../views/fund/salesDetail.vue')
        }, {
            path: '/fund/terminalDetail',
            meta: {
                title: '终端资金明细',
                name:'terminal_fund'
            },
            component: () => import('../views/fund/terminalDetail.vue')
        }, {
            path: '/chainTerminal/index',

            meta: {
                title: '连锁终端',
                name: 'chain_list',
            },
            component: () => import('../views/terminal/chainTerminal/index.vue')
        }, {
            path: '/chainTerminal/page',

            meta: {
                title: '广告项目',
                name: 'chain_page',
            },
            component: () => import('../views/terminal/chainTerminal/page.vue')
        }, {
            path: '/chainTerminal/addPage',
            meta: {
                title: '添加广告项目'
            },
            component: () => import('../views/terminal/chainTerminal/addPage.vue')
        }, {
            path: '/chainTerminal/pageInfo',
            meta: {
                title: '广告项目详情'
            },
            component: () => import('../views/terminal/chainTerminal/pageInfo.vue')
        }, {
            path: '/manager/list',
            meta: {
                title: '主管管理',
                name:'supervisor'
            },
            component: () => import('../views/manager/list.vue')
        }, {
            path: '/manager/add',
            meta: {
                title: '添加主管',
            },
            component: () => import('../views/manager/detail.vue')
        }, {
            path: '/manager/edit',
            meta: {
                title: '编辑主管',
            },
            component: () => import('../views/manager/detail.vue')
        }, {
            path: '/advertisement/reportList',
            meta: {
                title: '终端上报信息'
            },
            component: () => import('../views/advertisement/reportList.vue')
        }]
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
});
// router.onError((error) => {
//     const pattern = /Loading chunk (\d)+ failed/g;
//     const isChunkLoadFailed = error.message.match(pattern);
//     if (isChunkLoadFailed) {
//       location.reload();
//     }
// });

export default router;